import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { Grid, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { gql, useLazyQuery } from "@apollo/client";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import EditableText from "components/EditableText";

const PliegoParticularConcurso = () => {
  const currentYear = new Date().getFullYear();
  const documentsRef = useRef(null);
  const { id } = useParams();
  const { lg } = boxShadows;

  const [data, setData] = useState(null);
  const [textArray, setTextArray] = useState([
    "XXX",
    currentYear,
    "....................",
    "....................",
    "....................",
    "......./24",
    "XXX/" + currentYear,
    "....................",
    "00/00 ($......)",
    "....................", //10
    "los X (X) días",
    "....................",
    "....................", //13
    "00:00",
    "DÍA de MES de AÑO",
  ]);
  const [editable, setEditable] = useState(true);
  const [tipoPliego, setTipoPliego] = useState("concursos");

  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current.childNodes[0];
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "portrait",
      hotfixes: ["px_scaling"],
    });

    await doc.html(document, {
      margin: [50, 0, 50, 0],
      callback(doc) {
        doc.save(`exd-pedidoNro-${data.id}-Pliego particular.pdf`);
      },
    });
    setEditable(true);
  };

  const handleTextChange = (e, index) => {
    const newTextArray = [...textArray];
    newTextArray[index] = e.target.innerText;
    setTextArray(newTextArray);
  };

  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "794px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            {/* <PdfHeader /> */}

            <SoftBox pb={5}></SoftBox>
            <SoftBox px={1} pb={5}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                CONCURSO DE PRECIOS N°{" "}
                <EditableText
                  tooltip="Número de Concurso de Precios. Ej: (321)"
                  editable={editable}
                  content={textArray[0]}
                  handleOnBlur={(e) => handleTextChange(e, 0)}
                />
                -UPrO-
                <EditableText
                  tooltip="Año. Ej: (2024)"
                  editable={editable}
                  content={textArray[1]}
                  handleOnBlur={(e) => handleTextChange(e, 1)}
                />
              </SoftTypography>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                PLIEGO GENERAL DE CONDICIONES
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                OBJETO DEL LLAMADO
              </SoftTypography>
              <SoftTypography variant="body2" pb={3}>
                Llámese a CONCURSO DE PRECIOS, para la compra de{" "}
                <EditableText
                  tooltip="Descripción del objeto del llamado"
                  editable={editable}
                  content={textArray[2]}
                  handleOnBlur={(e) => handleTextChange(e, 2)}
                />
                , sede “UPrO -{" "}
                <EditableText
                  tooltip="Sede de la UPrO"
                  editable={editable}
                  content={textArray[3]}
                  handleOnBlur={(e) => handleTextChange(e, 3)}
                />
                ” solicitado por{" "}
                <EditableText
                  tooltip="Solicitado por"
                  editable={editable}
                  content={textArray[4]}
                  handleOnBlur={(e) => handleTextChange(e, 4)}
                />{" "}
                de la Universidad Provincial de Oficios “Eva Perón”. La contratación tramita por
                Expediente Nº{" "}
                <EditableText
                  tooltip="Número de Expediente"
                  editable={editable}
                  content={textArray[5]}
                  handleOnBlur={(e) => handleTextChange(e, 5)}
                />
                .-
              </SoftTypography>
              {tipoPliego === "concursos" && (
                <>
                  <SoftTypography variant="h6" fontWeight="bold">
                    ARTÍCULO 1°.-
                  </SoftTypography>
                  <SoftTypography variant="body2">
                    Los sobres cerrados, conteniendo las Ofertas (Propuesta Técnica y Económica)
                    podrán presentarse hasta las{" "}
                    <EditableText
                      tooltip="Hora ej(13:30)"
                      editable={editable}
                      content={textArray[14]}
                      handleOnBlur={(e) => handleTextChange(e, 14)}
                    />{" "}
                    horas del día{" "}
                    <EditableText
                      tooltip="Fecha ej(13 de Enero de 2022)"
                      editable={editable}
                      content={textArray[15]}
                      handleOnBlur={(e) => handleTextChange(e, 15)}
                    />{" "}
                    en que se procederá a su apertura.- Los sobres deberán contener además una copia
                    del Pliego General, del Pliego Particular, de los Anexos y Circulares
                    Aclaratorias (si correspondiere), del Formulario de Declaración Jurada de
                    Proveedor, de la Constancia de Inscripción ante AFIP, Constancia de Cuenta
                    Bancaria, Constancia de Inscripción y Certificado de Situación Fiscal Regular
                    Unificado emitidos por la Dirección de Ingresos Públicos de la Provincia y para
                    el caso de Sociedades Comerciales deberá adjuntar además: copia del Contrato
                    Social y copia de última Acta de designación de autoridades. La totalidad de la
                    documentación deberá ser firmada en todas sus hojas por el proveedor. La
                    documentación solicitada tiene carácter de obligatoria aun cuando ya hubiere
                    sido presentada en el Registro de Proveedores de la Universidad Provincial de
                    Oficios “Eva Perón” y sólo podrá otorgársele un plazo máximo de un (1) día desde
                    que fuera intimada a completarla en caso de faltante.
                  </SoftTypography>
                </>
              )}
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                PRESUPUESTO OFICIAL
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 2°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El presupuesto oficial para la presente concurso de precios es de PESOS{" "}
                <EditableText
                  tooltip="Presupuesto oficial"
                  editable={editable}
                  content={textArray[7]}
                  handleOnBlur={(e) => handleTextChange(e, 7)}
                />{" "}
                CON{" "}
                <EditableText
                  tooltip="Cantidad de decimales"
                  editable={editable}
                  content={textArray[8]}
                  handleOnBlur={(e) => handleTextChange(e, 8)}
                />
                .-
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                MANTENIMIENTO MÍNIMO DE LA OFERTA
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 3°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El Oferente deberá mantener la oferta por el término de cuarenta y cinco (45) días
                hábiles.
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                PLAZO MÁXIMO DE ENTREGA
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 4°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El bien y/o servicio solicitado, objeto de la presente concurso de precios, deberá
                ser prestado y/o entregado en la sede{" "}
                <EditableText
                  tooltip="Sede de la UPrO"
                  editable={editable}
                  content={textArray[9]}
                  handleOnBlur={(e) => handleTextChange(e, 9)}
                />{" "}
                de la Universidad Provincial de Oficios “Eva Perón” en un plazo no mayor a los{" "}
                <EditableText
                  tooltip="Plazo máximo de entrega"
                  editable={editable}
                  content={textArray[10]}
                  handleOnBlur={(e) => handleTextChange(e, 10)}
                />{" "}
                días de notificada la correspondiente orden de provisión en el domicilio electrónico
                constituido. –
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                OFERTA ECONÓMICA
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 5°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                En la oferta económica deberá especificarse :
              </SoftTypography>
              <SoftTypography
                variant="body2"
                sx={{
                  textIndent: "4em",
                }}
              >
                a) Consignando los precios unitarios y por ítems que se cotizan en pesos y deberán
                incluir todos los conceptos.
              </SoftTypography>
              <SoftTypography
                variant="body2"
                sx={{
                  textIndent: "4em",
                }}
              >
                b) El total general de la propuesta con{" "}
                <span
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  IVA incluido
                </span>
                .
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                DETALLE DEL SERVICIO
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 6°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                EL BIEN Y/O SERVICIO OBJETO DE LA PRESENTE CONCURSO DE PRECIOS DEBERÁ REUNIR LAS
                CARACTERÍSTICAS ESTABLECIDAS A CONTINUACIÓN:
              </SoftTypography>
              <Grid //Tabla de items
                container
                my={4}
                sx={{
                  border: "1px solid black",
                }}
              >
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Item
                </Grid>
                <Grid
                  xs={8}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Descripción
                </Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderBottom: "1px solid black",
                    backgroundColor: "rgb(206,206,240)",
                  }}
                >
                  Cantidad
                </Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  1
                </Grid>
                <Grid
                  xs={8}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  2
                </Grid>
                <Grid
                  xs={8}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderBottom: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  3
                </Grid>
                <Grid
                  xs={8}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                >
                  4
                </Grid>
                <Grid
                  xs={8}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderBottom: "1px solid black",
                  }}
                ></Grid>
                <Grid
                  xs={2}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                  }}
                >
                  5
                </Grid>
                <Grid
                  xs={8}
                  textAlign="center"
                  sx={{
                    borderRight: "1px solid black",
                  }}
                ></Grid>
                <Grid xs={2} textAlign="center"></Grid>
              </Grid>
              <SoftTypography variant="body2" fontWeight="bold">
                Los anexos correspondientes a Especificaciones Técnicas e Imágenes incorporadas al
                expediente y/o adjuntados a la invitación a participar de la Concurso de Precios
                forman parte del presente Pliego Particular, debiendo ser consideradas al momento de
                la presentación y evaluación de ofertas. –
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                EVALUACIÓN DE OFERTAS
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 7°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                Las ofertas serán evaluadas por el área solicitante y/o la Comisión Evaluadora que
                se designe al efecto debiendo preferir las que resulten más convenientes a los
                intereses de la Universidad y la satisfacción de las necesidades que fundamentarán
                la solicitud. Efectuada la selección deberá comunicarla a la Subdirección Compras y
                Contrataciones a fin de que éste las notifique a los oferentes; quienes podrán
                dentro del plazo de 24 hs. subsiguientes a la notificación, solicitar las
                aclaraciones o efectuar las impugnaciones que consideren pertinentes las que serán
                resueltas por el área legal previo informe del área solicitante. -
              </SoftTypography>
            </SoftBox>
            <SoftBox pb={3}>
              <SoftTypography
                variant="h6"
                fontWeight="bold"
                sx={{
                  textDecorationLine: "underline",
                }}
                textAlign="center"
              >
                CONDICIONES PARA EL PAGO
              </SoftTypography>
              <SoftTypography variant="h6" fontWeight="bold">
                ARTÍCULO 8°.-
              </SoftTypography>
              <SoftTypography variant="body2">
                El pago de las facturas correspondientes a la prestación de servicios y/o entrega de
                bienes se efectuará previa certificación de la finalización del mismo por parte del
                área solicitante.
              </SoftTypography>
            </SoftBox>
            <Grid container spacing={2} justifyContent="end">
              <Grid item xs={5} textAlign="center">
                <SoftBox
                  style={{
                    borderBottom: "1px solid black",
                    width: "100%",
                    display: "inline-block",
                    marginBottom: "0.5rem",
                  }}
                ></SoftBox>
                <SoftTypography variant="body2">
                  <EditableText
                    tooltip="Cargo del firmante"
                    editable={editable}
                    content={textArray[11]}
                    handleOnBlur={(e) => handleTextChange(e, 11)}
                  />
                </SoftTypography>
                <SoftTypography variant="body2">
                  Subdirección Compras y Contrataciones
                </SoftTypography>
                <SoftTypography variant="body2">
                  Universidad Provincial de Oficios Eva Perón
                </SoftTypography>
              </Grid>
            </Grid>
          </SoftBox>
        </div>
        <SoftBox
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default PliegoParticularConcurso;
